import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { H4 } from 'app/common/typography'
import { KingdomCard } from 'app/ecommerce/common'
import { breakpoints, media, ResponsiveContainer } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { isMobile } from 'react-device-detect'

const { red } = colors

type Tab = {
    id: string,
    name: string
}

type Props = {
    tabs: Array<Tab>,
    onTabClick?: Tab => void,
    currentTabId?: string
}

type State = {
    width: number,
    scrollPosition: number
}

class CatalogHeader extends Component<Props, State> {
    ref: any
    tabRefs: { [string]: any }

    constructor() {
        super()
        this.ref = React.createRef()
        this.tabRefs = {}
        this.state = {
            scrollPosition: window.scrollY,
            width: window.innerWidth
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.updateScrollPosition)
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentDidUpdate(prevProps: Props, prevState: State): void {
        const { currentTabId } = this.props
        const ref = currentTabId && this.tabRefs[currentTabId]
        ref &&
            ref.current &&
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.updateScrollPosition)
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateScrollPosition = () =>
        this.setState({ scrollPosition: window.scrollY })

    updateWindowDimensions = () => this.setState({ width: window.innerWidth })

    renderHeaderTab = (tab: Tab, index: number) => {
        const { currentTabId, onTabClick } = this.props
        const { id, name } = tab
        const ref = React.createRef()
        this.tabRefs[id] = ref
        return (
            <div ref={ref} key={index}>
                <TabContainer onClick={() => onTabClick && onTabClick(tab)}>
                    <H4 color="white">{name}</H4>
                    {id === currentTabId && <TabIndicator />}
                </TabContainer>
            </div>
        )
    }

    kingdomCardRender = () => {
        if (isMobile) {
            return <KingdomCard />
        }
        return (
            <ResponsiveContainer>
                <KingdomCard />
            </ResponsiveContainer>
        )
    }

    render() {
        const { tabs } = this.props
        const { scrollPosition, width } = this.state
        const isMobile = width < breakpoints.medium - 1
        const kingdomPushOffset = isMobile ? 56 : 80

        return (
            <Fragment>
                <RedContainer>{this.kingdomCardRender()}</RedContainer>
                <div ref={this.ref}>
                    <RedContainer
                        shouldStick={
                            this.ref.current &&
                            scrollPosition >=
                                this.ref.current.offsetTop - kingdomPushOffset
                        }>
                        <StyledMenu isMobile={isMobile}>
                            <ScrollSpy>
                                {tabs &&
                                    tabs.map((tab, index: number) =>
                                        this.renderHeaderTab(tab, index)
                                    )}
                            </ScrollSpy>
                        </StyledMenu>
                    </RedContainer>
                </div>
            </Fragment>
        )
    }
}

const RedContainer = styled.div`
    justify-content: center;
    background-color: ${red};
    ${props =>
        props.shouldStick &&
        `
        position: fixed;
        top: 55px;
        z-index: 20;
        width: 100%;
    `}
    ${media.medium`
        ${props =>
            props.shouldStick &&
            `
            top: 90px;
        `}
    `};
`

const StyledMenu = styled(ResponsiveContainer)`
    ${props =>
        props.isMobile &&
        `padding-bottom: 10px;
        margin: 0 0;
        width: 100%;
    `};
`

const TabContainer = styled.div`
    cursor: pointer;
    padding: 10px;
`

const ScrollSpy = styled.div`
    width: 100%;
    overflow: auto;
    display: -webkit-inline-box;
    margin-top: 10px;
    ${media.medium`
        margin-top: 20px;
    `};
`

const TabIndicator = styled.div`
    height: 4px;
    background-color: white;
    border-radius: 2px;
    top: -10px;
`

export { CatalogHeader }
